export default "__VITE_ASSET__5dc0a445__"